<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22" height="28" viewBox="0 0 22 28">
    <defs>
        <path id="b" d="M19.958 518.842c-.06-.163-.232-.437-.727-.437h-3.223c-.022 0-.032-.005-.034-.004a.116.116 0 0 1 .005-.042l1.312-5.047c.111-.427.221-1.02-.103-1.246-.325-.227-.7.181-.955.508l-5.961 7.651c-.337.433-.289.771-.23.934.06.163.232.436.727.436h3.223c.022 0 .03.004.034.005 0 .004.002.018-.005.042l-1.312 5.047c-.111.426-.221 1.02.103 1.246a.342.342 0 0 0 .201.065c.27 0 .551-.313.754-.574l5.961-7.65c.338-.433.289-.771.23-.934z"/>
        <filter id="a" width="280%" height="212.5%" x="-90%" y="-56.2%" filterUnits="objectBoundingBox">
            <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="3"/>
            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.0549019608 0 0 0 0 0.478431373 0 0 0 0 0.929411765 0 0 0 0.501557037 0"/>
        </filter>
    </defs>
    <g fill="none" fill-rule="nonzero" transform="translate(-4 -506)">
        <use fill="#000" filter="url(#a)" xlink:href="#b"/>
        <use fill="#0E7AED" xlink:href="#b"/>
    </g>
</svg>
